import { appyShopConfig } from '../config'
import { config } from '../config-merchant'
import { ContactDTO } from '../interfaces/contact-interfaces';
const axios = require('axios');

export function contactMerchant(contactBody: ContactDTO) {
    return axios.post(appyShopConfig.apiUrl + 'utils/' + config.merchantId + '/contact', contactBody)
}